module.exports = __webpack_public_path__ + "static/media/Country-Club-Village-PhaseIII-Second-Amendment.4dd93121.pdf";